import React, { useEffect, useState } from "react";
import { Box, Grid, LinearProgress, Typography } from "@mui/material";
import { BulkSalaryIncreaseProcessingState } from "../types";
import { useTranslation } from "react-i18next";

type Props = {
  processingState: BulkSalaryIncreaseProcessingState;
  total: number;
  currentProcessingIndex: number;
};

const BulkSalaryIncreaseProgressBar = ({
  processingState,
  total,
  currentProcessingIndex,
}: Props) => {
  const [currentProcessingState, setCurrentProcessingState] =
    useState<string>("idle");

  const { t } = useTranslation("common");

  useEffect(() => {
    if (processingState.isPreviewing) setCurrentProcessingState("idle");
    if (processingState.isProcessing) setCurrentProcessingState("inProgress");
    if (processingState.isCanceled) setCurrentProcessingState("canceled");
    if (processingState.isCompleted) setCurrentProcessingState("completed");
  }, [processingState]);

  return (
    <Grid item xs={12} sx={{ visibility: !total ? "hidden" : "visible" }}>
      <Box maxWidth="500px">
        {/* TODO: create component */}
        <Box
          display="flex"
          justifyContent="space-between"
          alignItems="center"
          mb="4px"
        >
          <Typography variant="header" fontWeight={600}>
            {t(currentProcessingState)}
          </Typography>
          <Typography variant="secondary">
            {`${currentProcessingIndex} / ${total}`}
          </Typography>
        </Box>
        <LinearProgress
          variant="determinate"
          value={(currentProcessingIndex / total) * 100}
        />
      </Box>
    </Grid>
  );
};

export default BulkSalaryIncreaseProgressBar;
